import React from 'react';
import { useMediaQuery } from 'react-responsive';
import FeaturesContent from './FeaturesContent';

const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 768 });
  return isDesktop ? children : null;
};

const DesktopResponsive = ({ history }) => (
  <Desktop>
    <FeaturesContent history={history} />
  </Desktop>
);

export default DesktopResponsive;
